import axios from 'axios';
const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/arrendadoras';

const arrendadorasApi = {
    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error fetching arrendadoras:', error);
            return [];
        }
    },

    detalle: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching informacion de arrendadora:', error);
            return null;
        }
    },

    crear: async (name: string) => {
        const response = await axios.post(
            `${BASE_URL}/crear`,
            { Name: name },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data as { Id: number; Name: string };
    },

    editar: async (id: string, name: string) => {
        try {
            const response = await axios.put(
                `${BASE_URL}/editar/${id}`,
                { Name: name },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error editando arrendadora:', error);
            return null;
        }
    },

    baja: async (id: string) => {
        try {
            const response = await axios.put(`${BASE_URL}/baja/${id}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error dando de baja arrendadora:', error);
            return null;
        }
    }
};

export default arrendadorasApi;
